/* @flow */
import React from 'react';

import cx from 'classnames';
import './styles/View.scss';

class View extends React.Component {
  static propTypes = {
    full: React.PropTypes.bool,
  };

  static defaultProps = {
    full: false,
  };

  render() {
    const { full, children, className, ...otherProps } = this.props;
    return (
      <div
        className={cx({
          View: true,
          'View-full': full,
        }, className)}
        {...otherProps}>
        {children}
      </div>
    );
  }
}

export default View;



// WEBPACK FOOTER //
// ./src/components/View.jsx